import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"

const BannerItem = styled.div`
  text-align: center;
  display: inline-block;
  margin-top: 15px;
`
const BannerItemText = styled.div`
  text-align: center;
  border: 1px darkgrey solid;
  background: darkgray;
  color: white;
  font-weight: bold;
`

const PerformanceBanner = (props) => {
  const { t } = props

  return (
    <div className="hidden-sm-down">
      <BannerItem className="col-lg-4 col-md-4">
        <BannerItemText>{t("Common.Low")}</BannerItemText>
      </BannerItem>
      <BannerItem className="col-lg-4 col-md-4">
        <BannerItemText>{t("Common.Medium")}</BannerItemText>
      </BannerItem>
      <BannerItem className="col-lg-4 col-md-4">
        <BannerItemText>{t("Common.High")}</BannerItemText>
      </BannerItem>
      <div className="col-lg-12 col-md-12" style={{ textAlign: "center", paddingTop: "10px" }}>
        <span style={{ color: "black" }}>{t("Common.Performance.Title")}</span>
      </div>
    </div>
  )
}

PerformanceBanner.propTypes = {
  t: PropTypes.func.isRequired,
}

export default translate()(PerformanceBanner)



// WEBPACK FOOTER //
// ./src/components/charts/nine-box-grid/PerformanceBanner.jsx